import apexchart from '../../../../node_modules/vue-apexcharts';

export default {
  name: 'Portfolio',
  components: {
    apexchart,
  },
  props: ['portfolioData', 'rankingLastRow', 'transactionData', 'reportData', 'annualReport','returnDistribution', 'quarterlyReturns', 'is_premium', 'isBrokerUser'],

  methods: {
    getTwoFixedVal(value) {
      if (
        isNaN(value)
        || value == 0
        || value == '-'
        || value == null
        || value == ''
      ) {
        return '-';
      }
      return parseFloat(value).toFixed(2);
    },
    getTwoFixedValElseZero(value) {
      if (
        isNaN(value)
        || value == 0
        || value == '-'
        || value == null
        || value == ''
      ) {
        return 0;
      }
      return parseFloat(value).toFixed(2);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },

    getAnnualReturns(chartData) {
      const data = [];
      for (let index = 0; index < 20; index++) {
        if (chartData[index] !== undefined) data.push(this.getTwoFixedVal(chartData[index].annual_returns));
      }
      return data;
    },

    getAnnualBenchmarkReturns(chartData) {
      const data = [];
      for (let index = 0; index < 20; index++) {
        if (chartData[index] !== undefined) data.push(this.getTwoFixedVal(chartData[index].annual_benchmark_returns));
      }
      return data;
    },
    getReturnDistributionXaxis(chartData){
      const data = [];
      _.forEach(chartData, function(element, key) {
        data.push(element.index);
      });
      return data;
    },
    getReturnDistributionYaxis(chartData){
      const data = [];
      _.forEach(chartData, function(element, key) {
        data.push(element.count);
      });
      return data;
    },

    getAnnualYears(chartData) {
      const data = [];
      for (let index = 0; index < 20; index++) {
        if (chartData[index] !== undefined) data.push(chartData[index].years);
      }
      return data;
    },
    getQuarterlyData() {
      const data = [];
      for (let index = 0; index < 20; index++) {
        if (this.quarterlyReturns[index] !== undefined) {
          const obj = {
            name: this.quarterlyReturns[index].years,
            data: [
              {
                x: 'Quarter1',
                y: this.getTwoFixedValElseZero(this.quarterlyReturns[index].Quarter1),
              },
              {
                x: 'Quarter2',
                y: this.getTwoFixedValElseZero(this.quarterlyReturns[index].Quarter2),
              },
              {
                x: 'Quarter3',
                y: this.getTwoFixedValElseZero(this.quarterlyReturns[index].Quarter3),
              },
              {
                x: 'Quarter4',
                y: this.getTwoFixedValElseZero(this.quarterlyReturns[index].Quarter4),
              },
            ],
          };
          data.push(obj);
        }
      }
      return data;
    },
  },
  computed: {
    customTicks(value) {
      return [-40, -20, 0, 20, 40, 60, 80, 100, 120];
    },

    annualChartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '75%',
            endingShape: 'flat',
            dataLabels: {
              // position top for the bar chart (puts labels above each bar)
              position: 'top'
            }
          },
        },
        colors: ['#006cd7', '#adcef9'],
        dataLabels: {
          enabled: true,
          offsetY: -10,
          style: {
            fontSize: '8px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: '600',
            colors: ['#2E294E'],
          },
          background: {
            enabled: true,
            foreColor: '#fff',
            padding: 6,
            borderRadius: 4,
            borderWidth: 0,
            opacity: 0.95
          },
          formatter(val, opts) {
            const threshold = 3; // percent
            if (Math.abs(val) < threshold) return '';

            return `${val}%`;
          },
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['transparent'],
        },
        xaxis: {
          categories: this.getAnnualYears(this.annualReport),
          labels: {
            style: {
              colors: '#666',
              fontSize: '13px',
              fontFamily: "Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              fontWeight: 500,
            },
            formatter(val) {
              return `${val}`;
            },
          },
        },
        yaxis: [
          {
            min: this.customTicks[0],
            max: this.customTicks[this.customTicks.length - 1],
            tickAmount: this.customTicks.length - 1,
            title: {
              text: 'Actual Returns (%)',
            },
            labels: {
              style: {
                colors: '#666',
                fontSize: '13px',
                fontFamily: "Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                fontWeight: 500,
              },
              formatter: (val) => {
                return this.customTicks.includes(val) ? `${val}%` : '';
              },
            },
          },
          {
            min: this.customTicks[0],
            max: this.customTicks[this.customTicks.length - 1],
            opposite: true,
            title: { 
              text: 'Benchmark (%)', 
              style: { 
                color: '#666',
              }
            },
            labels: {
              style: { 
                colors: '#666',
                fontSize: '13px',
                fontFamily: "Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                fontWeight: 500,
              },
              formatter: (val) => `${val}%`
            }
          }
        ],
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter(val) {
              return ` ${val} `;
            },
          },
        },
      }
    },
  },
  data() {
    return {
      annualSeries: [{
        name: 'Annual Returns',
        data: this.getAnnualReturns(this.annualReport),
      }, {
        name: 'Annual Benchmark Returns',
        data: this.getAnnualBenchmarkReturns(this.annualReport),
      }],
      quarterlyChartSeries: this.getQuarterlyData(),
      quarterlyChartOptions: {
        chart: {
          height: 350,
          type: 'heatmap',
          toolbar: {
            show: true,
            tools: {
              download: false,
            },
          },
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
          //offsetX: 110,
        },
        stroke: {
          show: true,
          width: 1,
        },
        plotOptions: {
          heatmap: {
            shadeIntensity: 0.5,
            radius: 0,
            useFillColorAsStroke: true,
            colorScale: {
              ranges: [{
                from: -100.00,
                to: -1.00,
                name: '(<0%)',
                color: '#f1f6fe'//'#FEB019',
              },
              {
                from: -0.99,
                to: 10.00,
                name: '(0-10%)',
                color: '#468fec'//'#F9CE1D',
              },
              {
                from: 10.01,
                to: 20.00,
                name: '(10-20%)',
                color: '#00FF00'//'#00E396',
              },
              {
                from: 20.01,
                to: 100.00,
                name: '(>20%)',
                color: '#006400'//'#4CAF50',
              },
              ],
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: '400',
            colors: ['#2E294E'],
          },
          formatter(val, opts) {
            return `${val}%`;
          },
        },
        colors: ['#A300D6'],
        // grid: {
        //   position: 'front',
        //   xaxis: {
        //     lines: {
        //       show: true,
        //     },
        //   },
        //   yaxis: {
        //     lines: {
        //       show: true,
        //     },
        //   },
        // },
        labels: {
          formatter(val, index) {
            return val.toFixed(2);
          },
        },
        xaxis: {
          type: 'category',
          categories: [],
          labels: {

            style: {
              colors: '#666',
              fontSize: '13px',
              fontFamily: "Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              fontWeight: 500,
            },
          },
        },
        yaxis: {
          tickAmount: 6,
          labels: {

            style: {
              colors: '#666',
              fontSize: '13px',
              fontFamily: "Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              fontWeight: 500,
            },
          },
        },
        tooltip: {
          shared: false,
          x: {
            formatter(val) {
              return val;
            },
          },
          y: {
            formatter(val) {
              return `${Math.abs(val)}%`;
            },
          },
        },
      },
      returnDistributionSeries: [{
        name: 'Transactions Count',
        data:this.getReturnDistributionYaxis(this.returnDistribution)
      }],
      returnDistributionChartOptions: {
        chart: {
          height: 350,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val;
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ["#304758"]
          }
        },

        xaxis: {
          categories: this.getReturnDistributionXaxis(this.returnDistribution),
          position: 'bottom',
          title: {
            text: 'Returns %',
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          labels: {
            show: true,
            formatter: function (val) {
              return val + " %";
            }
          },
          crosshairs: {
            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#D8E3F0',
                colorTo: '#BED1E6',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              }
            }
          },
          tooltip: {
            enabled: true,
          }
        },
        yaxis: {
          axisBorder: {
            show: false
          },
          title: {
            text: 'Transactions Count',
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: true,
            formatter: function (val) {
              return val + "";
            }
          }

        },
        title: {
          text: '',
          floating: true,
          offsetY: 330,
          align: 'center',
          style: {
            color: '#444'
          }
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/Report/Performance.js